import { defineStore } from 'pinia';
import authApi from '@/api/auth';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    business: null,
    loading: false,
  }),

  getters: {
    isAuthenticated: (state) => !!state.user,
    fullName: (state) => state.user ? `${state.user.firstName} ${state.user.lastName}` : '',
    businessName: (state) => state.user?.businessName || '',
  },

  actions: {
    async register(payload) {
      this.loading = true;
      try {
        const { data } = await authApi.register(payload);
        this.user = data.user;
        return data;
      } finally {
        this.loading = false;
      }
    },

    async login(email, password) {
      this.loading = true;
      try {
        const { data } = await authApi.login(email, password);
        this.user = data.user;
        await this.fetchUser();
        return data.user;
      } finally {
        this.loading = false;
      }
    },

    async logout() {
      try {
        await authApi.logout();
      } finally {
        this.user = null;
      }
    },

    async fetchUser() {
      try {
        const { data } = await authApi.getMe();
        this.user = data.user;
        this.business = data.business || null;
        return data.user;
      } catch {
        this.user = null;
        this.business = null;
        return null;
      }
    },
  },
});
